@if (faqFeedback && faqFeedback.feedbackTitle) {
  <div class="feedback__container">
    <div class="container">
      @if (!faqFeedbackReceived) {
        <div class="feedback__content">
          <div class="feedback__title">
            {{ faqFeedback.feedbackTitle }}
          </div>
          <div class="feedback__buttons-container">
            <button type="button" class="feedback-button" (click)="onFaqFeedbackReceived()">
              <div class="feedback-button-wrapper">
                <img [src]="'assets/images/icons/thumbs-up.svg' | staticFileHash" [alt]="faqFeedback.feedbackYesLabel" />
              </div>
            </button>
            <button type="button" class="feedback-button" (click)="onFaqFeedbackReceived()">
              <div class="feedback-button-wrapper">
                <img [src]="'assets/images/icons/thumbs-down.svg' | staticFileHash" [alt]="faqFeedback.feedbackNoLabel" />
              </div>
            </button>
          </div>
        </div>
      }
      @if (faqFeedbackReceived) {
        <div class="feedback__title">
          {{ faqFeedback.feedbackMessage }}
        </div>
      }
    </div>
  </div>
}
